import Vue from 'vue';

var Emit = new Vue({});

export{
    Emit
}